import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';

import { LoaderService } from '@teem/core/services/loader.service';
import { UserService } from '@teem/core/services/user.service';
import { messages as i18n } from '@teem/core/constants/messages';
import { country as CountryApi } from '@teem/core/constants/api';
import { UserForm } from '@teem/core/model-forms/user-form';
import { User } from '@teem/core/models/user';


@Component({
  selector: 'app-add-user-modal',
  templateUrl: './add-user-modal.component.html',
  styles: []
})

export class AddUserModalComponent implements OnInit {
  
	@ViewChild('newUserForm') newUserForm: FormGroupDirective;
	userForm: FormGroup;
	submitted: boolean = false;
	countryListApi: string = CountryApi.endPoint;
	roles: any = [
		{ name: $localize`:@@ts.common.user:User`, id: 'user' },
		{ name: $localize`:@@ts.common.admin:Admin`, id: 'admin' },
		// { name: $localize`:@@ts.common.super_admin:Super Admin`, id: 'super_admin' },
	];

	constructor(
		private fb: FormBuilder,
		private userService: UserService,
		private loaderService: LoaderService,
		public activeModal: NgbActiveModal,
		private el:ElementRef
	) { }

	ngOnInit(): void {
		this.userForm = this.fb.group(new UserForm(new User()),
		{
		  validators: this.matchValidator('password', 'confirm_password')
		});

		const passwordControl = this.userForm.get('password');
		const confirmpasswordControl = this.userForm.get('confirm_password');
		passwordControl.setValidators([Validators.required]);
		confirmpasswordControl.setValidators([Validators.required]);
	}

	matchValidator(controlName: string, matchingControlName: string): ValidatorFn {
		return (abstractControl: AbstractControl) => {
			const control = abstractControl.get(controlName);
			const matchingControl = abstractControl.get(matchingControlName);
	
			if (matchingControl!.errors && !matchingControl!.errors?.['confirmedValidator']) {
				return null;
			}
	
			if (control!.value !== matchingControl!.value) {
			  const error = { confirmedValidator: 'Passwords do not match.' };
			  matchingControl!.setErrors(error);
			  return error;
			} else {
			  matchingControl!.setErrors(null);
			  return null;
			}
		}
	  }

	submit() {
		if(this.userForm.valid) {
			this.submitted = true;
			this.loaderService.startLoading();
			this.userService.createTeemUser(this.userForm.value, {headers: {'Content-Type': 'multipart/form-data'}}).subscribe(data => {
				this.loaderService.stopLoading();

				this.userForm.reset();
				this.activeModal.close(data);
				
				Swal.fire(i18n.done,  i18n.user.user_saved, 'success');
				this.submitted = false;				
			}, err => {
				this.loaderService.stopLoading();
				// Set server side error
				if(err.status === 422) {
					if(err.error && err.error.errors && Object.keys(err.error.errors).length) {
						let validationErrors = err.error.errors;
						Object.keys(validationErrors).forEach((prop) => {
							this.userForm.get(prop)?.setErrors({
								serverError: validationErrors[prop]
							})
						})
					}
				}

				Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
			});
		}
	}
}
